import React, { ReactNode } from "react";
import { Form } from "react-bootstrap";

interface PaymentMethodItemProps {
  id: string;
  isSelected: boolean;
  onClick: (id: string) => void;
  children: ReactNode;
  radioName?: string;
}

const PaymentMethodItem = ({ 
  id, 
  isSelected, 
  onClick, 
  children, 
  radioName = "paymentMethod" 
}: PaymentMethodItemProps) => {
  return (
    <div 
      className="d-flex align-items-center p-3 mb-2"
      style={{
        backgroundColor: isSelected 
          ? "rgba(255, 193, 7, 0.08)" 
          : "rgba(255, 255, 255, 0.02)",
        border: `1px solid ${isSelected ? 'rgba(255, 193, 7, 0.3)' : 'rgba(255, 255, 255, 0.1)'}`,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: isSelected 
          ? '0 2px 8px rgba(255, 193, 7, 0.1)' 
          : 'none'
      }}
      onClick={() => onClick(id)}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.02)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
        }
      }}
    >
      <div style={{ marginRight: "12px" }}>
        <Form.Check
          type="radio"
          name={radioName}
          checked={isSelected}
          readOnly
          style={{ 
            accentColor: '#ffc107',
            transform: 'scale(1.1)'
          }}
        />
      </div>
      
      <div className="flex-grow-1">
        {children}
      </div>
    </div>
  );
};

export default PaymentMethodItem; 